import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import AfterSalesRefundsReturn from './AfterSalesRefundsReturn.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToMany,
    widget: 'AfterSalesRefundsReturn',
    multi: true
  })
)
export class DetailM2mMultiAfterSalesRefundsReturnFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(AfterSalesRefundsReturn);
    return this;
  }
}